import { useStore } from '../core/store';
import { LoadableStatus } from '../mobx-utils';
import { useEffect, useState } from 'react';

/**
 * returns useful information about the booking date
 * e.g. "isActiveBooking" or "isPastBooking" or "isFutureBooking"
 */
export function useBookingDate(offsetStart = 0, offsetEnd = 0) {
  const { BookingStore } = useStore();

  const { data, status } = BookingStore.booking;

  const [config, setConfig] = useState({
    isActiveBooking: false,
    isFutureBooking: false,
    isPastBooking: false,
    isSpecialCampaign: false,
  });

  useEffect(() => {
    if (status === LoadableStatus.done) {
      const today = new Date();
      const startDate = toDate(data.startDate);
      const endDate = toDate(data.endDate);

      setConfig({
        isActiveBooking:
          today >= dateOffset(startDate, offsetStart) &&
          today <= dateOffset(endDate, offsetEnd),
        isFutureBooking: today < startDate,
        isPastBooking: today > endDate,
        isSpecialCampaign:
          today >= dateOffset(startDate, offsetStart) &&
          today <= dateOffset(startDate, offsetEnd),
      });
    }
  }, [status]);

  return config;
}

const toDate = (date) => {
  const [day, month, year] = date.split('.');
  return new Date(year, month - 1, day);
};

const dateOffset = (date, hours) => {
  // offset in milliseconds
  const newDate = new Date(date.getTime() + hours * 60 * 60 * 1000);
  return newDate;
};
